import { Button } from "@mui/material";
import React from "react";
import { FaSignOutAlt } from "react-icons/fa";

function LogoutButton({ onClick }) {
  return (
    <div className="text-center">
      <Button
        sx={{
          textTransform: "initial",
          width: "80%",
        }}
        color="error"
        variant="contained"
        startIcon={<FaSignOutAlt />}
        onClick={onClick}
      >
        Log Out
      </Button>
    </div>
  );
}

export default LogoutButton;
